import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='BanksComponent' subtitle="PrimerHeadlessMainComponent<BanksCollectableData, BanksStep>" mdxType="Item">
        <p>The <code>BanksComponent</code> provides a protocol extending the <code>PrimerHeadlessMainComponent</code> protocol where Data is of  type <code>BanksCollectableData</code> and Step is of type <code>BanksStep</code></p>
      <pre><code parentName="pre" {...{
          "className": "language-swift"
        }}>{`public protocol BanksComponent: PrimerHeadlessMainComponent where Data == BanksCollectableData, Step == BanksStep { }
`}</code></pre>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      